import Login from "../../components/Login/Login";
import Nav from "../../components/Nav/Nav";
import { Helmet } from "react-helmet-async";

function Connection() {
  return (
    <div>
      <Helmet>
        <title>Connexion - Espace privé</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Nav />
      <div className="login">
        <div className="login__header">
          <div className="login__logo">
            <img
              className="logo-connection"
              src="../images/logocabinet_compress.png"
              alt="logocabinet"
            />
          </div>
          <h1>Espace privé</h1>
        </div>
        <div className="login-page">
          <Login />
        </div>
      </div>
    </div>
  );
}

export default Connection;
